
import { i18nText } from '@/locales';

import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ProxyDataForm } from '@/UI/components/Helpers/ProxyDataForm';
import { StoresStore } from '@/store/modules/Warehouse/Warehouse';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import { Table, Row } from 'ant-design-vue';
import { ITableColumn } from '@/entity/table/table.types';
import { StoreMix } from '@/UI/mixins/Store/StoreMix';
import { RouterNameEnum } from '@/router/router.types';

@Component({
    components: {
        BaseDataForm,
        'a-table': Table,
        'a-row': Row,
    },
})
export default class SelectStore extends mixins(ProxyDataForm, StoreMix) {
    RouterNames = RouterNameEnum;
    get columns(): ITableColumn[] {
        return [
            {
                title: i18nText("наименование"),
                dataIndex: 'name',
                key: 'name',
                scopedSlots: { customRender: 'name' },
            },
        ];
    }

    async created(): Promise<void> {
        try {
            if (!StoresStore.ready) {
                await StoresStore.fetchAll({ limit: this.AppPageParams.pageSize });
                StoresStore.setReady(true);
            }
            this.formReady = true;
            this.tableLoad = true;
        } catch (e) {
            console.log('Parse Stores Data Error ----');
        }
    }
}
